import React, { use, useEffect, useState } from "react";
import {
    Box,
    Typography,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Checkbox,
    Button,
    Grid,
    Container,
    Card,
    CardContent,
    useTheme,
    useMediaQuery,
    Chip,
    Stack,
    Divider,
    TextField,
    InputAdornment,
    Tooltip,
    IconButton
} from '@mui/material';
import { styled } from '@mui/material/styles';
import VerifiedIcon from '@mui/icons-material/Verified';
import PersonIcon from '@mui/icons-material/Person';
import ColorData from 'Components/CstmTheme/ColorData';
import MobileUserCard from './MobileUserCard';
import SearchIcon from '@mui/icons-material/Search';
import RefreshIcon from '@mui/icons-material/Refresh';
import AdminApi from 'Service/Admin.api';
import { useDispatch } from 'react-redux';
import { setAlertData, startLoading, stopLoading } from '../../Redux/Screen/Action';
import { HeaderCard } from './ProfessionalUserList';
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    fontWeight: "bold",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    fontSize: "1rem",
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    "&:hover": {
        backgroundColor: theme.palette.action.selected,
    },
}));

const CorporateList = () => {
    const [selectedUsers, setSelectedUsers] = useState<number[]>([]);
    const [users, setUsers] = useState([]);
    const theme = useTheme();

    // Enhanced responsive breakpoints
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const isDesktop = useMediaQuery(theme.breakpoints.up("lg"));
    const [searchQuery, setSearchQuery] = useState("");
    const dispatch = useDispatch();

    useEffect(() => {
        if (searchQuery === "") fetchListData();
        else {
            const filteredUsers = users.filter((user: any) =>
                `${user.firstName} ${user.lastName}`
                    .toLowerCase()
                    .includes(searchQuery.toLowerCase())
            );
            setUsers(filteredUsers);
        }
    }, [searchQuery]);

    useEffect(() => {
        fetchListData();
    }, []);

    const fetchListData = async () => {
        try {
            dispatch(
                startLoading({
                    loading: true,
                    loadtext: "Fetching Corporate User Data...",
                })
            );
            const response = await AdminApi.CorporateList({
                userType: "CORPORATEUSER",
            });
            if (response?.success && Array.isArray(response?.data)) {
                setUsers(response.data);
            } else {
                setUsers([]); // Ensure it's an array even if no data
            }
            dispatch(stopLoading());
        } catch (error) {
            dispatch(stopLoading());
        }
    };
    const handleSelectUser = (userId: number) => {
        setSelectedUsers((prev) =>
            prev.includes(userId)
                ? prev.filter((id) => id !== userId)
                : [...prev, userId]
        );
    };

    const handleVerifySelected = () => {
        setUsers((prev: any) =>
            prev.map((user: any) =>
                selectedUsers.includes(user.id) ? { ...user, isVerified: true } : user
            )
        );
        setSelectedUsers([]);
    };
    console.log("users--->", users);
    const handleVerifyUser = async (user: any) => {
        const { email } = user;
        try {
            const response = await AdminApi.VerifyCorporate({
                email: email,
                userType: "CORPORATEUSER",
            });
            if (response?.success) {
                dispatch(
                    setAlertData({
                        alertMessage: "User Verified Successfully",
                        alertVariant: "success",
                        openAlert: true,
                    })
                );
            }
            await fetchListData();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    return (
        <Container
            maxWidth="xl"
            sx={{
                py: { xs: 2, sm: 3, md: 4 },
                px: { xs: 1, sm: 2, md: 3 }
            }}
        >
            <Grid container spacing={{ xs: 2, sm: 2, md: 3 }}>
                {/* Header Section - Responsive Grid */}
                {/* <Grid size={{ xs: 12, sm: 12, md: 8, lg: 8 }}>
                    <Card
                        elevation={3}
                        sx={{
                            mb: { xs: 2, md: 2 },
                            borderRadius: { xs: 2, md: 3 }
                        }}
                    >
                        <CardContent sx={{ p: { xs: 2, sm: 3, md: 3 } }}>
                            <Box
                                display="flex"
                                alignItems="center"
                                gap={{ xs: 1, sm: 2 }}
                                mb={{ xs: 1, sm: 2 }}
                                flexDirection={isMobile ? 'column' : 'row'}
                            >
                                <VerifiedIcon
                                    color="primary"
                                    sx={{
                                        fontSize: { xs: 28, sm: 32, md: 40 }
                                    }}
                                />
                                <Typography
                                    variant={isMobile ? "h6" : isTablet ? "h5" : "h4"}
                                    component="h1"
                                    fontWeight="bold"
                                    color="primary"
                                    textAlign={isMobile ? "center" : "left"}
                                    sx={{
                                        fontSize: { xs: '1.25rem', sm: '1.5rem', md: '2rem' }
                                    }}
                                >
                                    Verify Corporate Users
                                </Typography>
                            </Box>
                            <Typography
                                variant={isMobile ? "body2" : "body1"}
                                color={ColorData.text.primary}
                                textAlign={isMobile ? "center" : "left"}
                                sx={{
                                    fontSize: { xs: '0.875rem', sm: '1rem' }
                                }}
                            >
                                Manage and verify corporate user accounts
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid> */}

                {/* Action Buttons - Responsive Grid */}
                {/* <Grid size={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Box
                        display="flex"
                        gap={{ xs: 1, sm: 1.5, md: 2 }}
                        mb={2}
                        flexWrap="wrap"
                        justifyContent={{ xs: "center", sm: "center", md: "flex-end" }}
                        alignItems="center"
                        sx={{
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' },
                            width: '100%'
                        }}
                    >
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleVerifySelected}
                            disabled={selectedUsers.length === 0}
                            startIcon={<VerifiedIcon />}
                            size={isMobile ? "small" : "medium"}
                            sx={{
                                minWidth: { xs: '200px', sm: 'auto' },
                                fontSize: { xs: '0.75rem', sm: '0.875rem' }
                            }}
                        >
                            Verify Selected ({selectedUsers.length})
                        </Button>
                        <Chip
                            icon={<PersonIcon />}
                            label={`Total Users: ${users.length}`}
                            color="info"
                            variant="outlined"
                            sx={{
                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                height: { xs: 28, sm: 32 }
                            }}
                        />
                    </Box>
                </Grid> */}

                <HeaderCard sx={{ width: '100%', borderRadius: { xs: 2, md: 3 } }}>
                    <CardContent sx={{ p: { xs: 2, sm: 4, md: 5 } }}>
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            flexDirection={isMobile ? 'column' : 'row'}
                            gap={2}
                        >
                            <Box display="flex" alignItems="center" gap={2}>
                                <VerifiedIcon sx={{ fontSize: { xs: 40, sm: 48, md: 56 } }} />
                                <Box>
                                    <Typography
                                        variant={isMobile ? "h5" : "h4"}
                                        component="h1"
                                        fontWeight="bold"
                                        color={ColorData.text.secondary}
                                        gutterBottom
                                    >
                                        Corporate User Management
                                    </Typography>
                                    <Typography
                                        variant="body1"
                                        sx={{ opacity: 0.9 }}
                                    >
                                        Verify and manage corporate user accounts with ease
                                    </Typography>
                                </Box>
                            </Box>

                            <Tooltip title="Refresh Data">
                                <IconButton
                                    // onClick={handleRefresh}
                                    // disabled={refreshing}
                                    sx={{
                                        bgcolor: 'rgba(255,255,255,0.2)',
                                        color: 'inherit',
                                        '&:hover': {
                                            bgcolor: 'rgba(255,255,255,0.3)',
                                            transform: 'rotate(180deg)',
                                        },
                                        transition: 'all 0.3s ease',
                                    }}
                                >
                                    <RefreshIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </CardContent>
                </HeaderCard>

                {/* Mobile Select All - Only visible on mobile */}
                {isMobile && (
                    <Grid size={{ xs: 12 }}>
                        <Card elevation={1} sx={{ mb: 2 }}>
                            <CardContent sx={{ p: 2 }}>
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    justifyContent="space-between"
                                >
                                    <Typography variant="body2" fontWeight="medium">
                                        Select All Users
                                    </Typography>
                                    <Checkbox
                                        indeterminate={
                                            selectedUsers.length > 0 &&
                                            selectedUsers.length < users.length
                                        }
                                        checked={
                                            users.length > 0 && selectedUsers.length === users.length
                                        }
                                        onChange={(e) => {
                                            if (e.target.checked) {
                                                setSelectedUsers(users.map((user: any) => user?.id));
                                                // setSelectedUsers(users.map(user => user?.id || 0));
                                            } else {
                                                setSelectedUsers([]);
                                            }
                                        }}
                                    />
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>
                )}

                {/* Content Section - Conditional Rendering */}
                <Grid size={{ xs: 12 }}>
                    <Box display="flex" justifyContent="flex-start" mb={2}>
                        <TextField
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder="Search coporate users..."
                            size="small"
                            sx={{ width: { xs: '100%', sm: '300px' } }}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon />
                                    </InputAdornment>
                                ),
                            }}
                        />

                        <Chip
                            icon={<PersonIcon />}
                            label={`Total Users: ${users.length}`}
                            color="info"
                            variant="outlined"
                            sx={{
                                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                                height: { xs: 28, sm: 32 }
                            }}
                        />
                    </Box>
                    {isMobile ? (
                        // Mobile Card View
                        <Box>
                            {users?.map((user: any, index) => (

                                <MobileUserCard
                                    key={user?.id}
                                    user={user}
                                    index={index}
                                    selectedUsers={selectedUsers}
                                    handleSelectUser={handleSelectUser}
                                    handleVerifyUser={handleVerifyUser}
                                />
                            ))}
                        </Box>
                    ) : (


                        // Desktop/Tablet Table View
                        <Paper
                            elevation={2}
                            sx={{
                                overflowX: 'auto',
                                borderRadius: { xs: 2, md: 3 },
                            }}
                        >
                            <TableContainer
                                sx={{
                                    maxHeight: { xs: 500, sm: 600, md: 700 },
                                    minWidth: isTablet ? 700 : 'auto',
                                }}
                            >
                                <Table
                                    stickyHeader
                                    size={isTablet ? 'small' : 'medium'}
                                >
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>S.No</StyledTableCell>
                                            <StyledTableCell>First Name</StyledTableCell>
                                            <StyledTableCell>Last Name</StyledTableCell>
                                            <StyledTableCell>Email</StyledTableCell>
                                            <StyledTableCell>Mobile Number</StyledTableCell>
                                            <StyledTableCell>Org Name</StyledTableCell>
                                            <StyledTableCell>Status</StyledTableCell>
                                            <StyledTableCell align="center">Action</StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    {users.length === 0 ? (
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={8}>
                                                    <Box
                                                        display="flex"
                                                        justifyContent="center"
                                                        alignItems="center"
                                                       
                                                    >
                                                        <Typography variant="body2">No Corporate Users Found.</Typography>
                                                    </Box>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    ) : (
                                        <TableBody>
                                            {users?.map((user: any, index) => (
                                                    <StyledTableRow key={user.id}>
                                                        <TableCell>
                                                            <Typography variant="body2" fontWeight="medium">
                                                                {index + 1}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography
                                                                variant="body2"
                                                                fontWeight="medium"
                                                                sx={{ fontSize: { sm: '0.875rem', md: '1rem' } }}
                                                            >
                                                                {user.firstName}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography
                                                                variant="body2"
                                                                fontWeight="medium"
                                                                sx={{ fontSize: { sm: '0.875rem', md: '1rem' } }}
                                                            >
                                                                {user.lastName}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography
                                                                variant="body2"
                                                                color={ColorData.text.primary}
                                                                sx={{ fontSize: { sm: '0.875rem', md: '1rem' } }}
                                                            >
                                                                {user.email}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography
                                                                variant="body2"
                                                                color={ColorData.text.primary}
                                                                sx={{ fontSize: { sm: '0.875rem', md: '1rem' } }}
                                                            >
                                                                {user.phoneNumber}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Typography
                                                                variant="body2"
                                                                color={ColorData.text.primary}
                                                                sx={{ fontSize: { sm: '0.875rem', md: '1rem' } }}
                                                            >
                                                                {user.corporateOrgName}
                                                            </Typography>
                                                        </TableCell>
                                                        <TableCell>
                                                            <Chip
                                                                label={user.isVerified ? 'Verified' : 'Pending'}
                                                                color={user.isVerified ? 'success' : 'warning'}
                                                                size={isTablet ? 'small' : 'medium'}
                                                                icon={user.isVerified ? <VerifiedIcon /> : undefined}
                                                                sx={{
                                                                    fontSize: { sm: '0.75rem', md: '0.875rem' }
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Button
                                                                variant={user.isVerified ? "outlined" : "contained"}
                                                                color="primary"
                                                                size={isTablet ? "small" : "medium"}
                                                                onClick={() => handleVerifyUser(user)}
                                                                disabled={user.isVerified}
                                                                startIcon={<VerifiedIcon />}
                                                                sx={{
                                                                    fontSize: { sm: '0.75rem', md: '0.875rem' },
                                                                    minWidth: { sm: '80px', md: '100px' }
                                                                }}
                                                            >
                                                                {user.isVerified ? 'Verified' : 'Verify'}
                                                            </Button>
                                                        </TableCell>
                                                    </StyledTableRow>
                                                ))}
                                        </TableBody>
                                    )}
                                </Table>
                            </TableContainer>
                        </Paper>
                    )}
                </Grid>
            </Grid>
        </Container>
    );
};

export default CorporateList;
